<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Nova Parceria'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field
                      label='Nome do parceiro institucional/colaborador'
                      v-model="parceria.nome"
                      required
                      :rules="assuntoSummaryRules255"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label='Descrição da parceria/colaboração'
                      v-model="parceria.detalhamento"
                      required
                      :rules="assuntoSummaryRules255"
                      :rows="3"
                      :auto-grow="true"
                      multi-line
                      counter="255"
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarParceria(false)" :disabled="!formularioValido">Criar</v-btn>
              <v-btn color="primary" text @click="criarParceria(true)" :disabled="!formularioValido">Criar e Avançar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      parceria: {
        nome: '',
        detalhamento: ''
      },
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules255: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ParceriasProjeto', params: {idProjeto: this.idProjeto}})
      },
      criarParceria: function (avancar) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova parceria.' })
        projetos.postParceriasDoProjeto(this.idProjeto, this.parceria)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          if (avancar === false) {
            this.parceria.nome = ''
            this.parceria.detalhamento = ''
            this.$router.push({name: 'ParceriasProjeto', params: {idProjeto: this.idProjeto}})
          } else {
            this.$router.push({name: 'NovaLocalidade', params: {idProjeto: this.idProjeto}})
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova parceria.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.dataInicioFormatada = this.dates.format(this.projeto.dataInicio)
        this.dataConclusaoFormatada = this.dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// nova-parceria.vue?081cb94b